/* MRD Mobile Carousel Stability — 2026-11-02
 * Safe reconciliation for homepage logo and testimonial sliders on
 * mobile Safari/Chrome; Venue/Slick remains the primary carousel.
 * No mutation of desktop layouts, product galleries, or checkout. */
(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-index')) return;

  var selector = '.home-logo-list--mob-carousel .js-home-logo-list-carousel, ' +
    '.home-testimonials--mob-carousel .js-home-testimonials-carousel';
  var handle = null;

  function isMobile() {
    return window.matchMedia ? window.matchMedia('(max-width: 767px)').matches
      : window.innerWidth < 768;
  }

  function refreshMobileCarousels() {
    handle = null;
    if (!isMobile() || !window.jQuery || !window.jQuery.fn ||
        typeof window.jQuery.fn.slick !== 'function') return;

    var $ = window.jQuery;
    $(selector).each(function () {
      var slider = $(this);
      if (!slider.is(':visible')) return;
      if (!slider.data('carouselMobile')) return;

      try {
        if (!slider.hasClass('slick-initialized')) {
          if (slider.hasClass('js-home-logo-list-carousel')) {
            slider.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              swipeToSlide: true,
              variableWidth: true,
              arrows: false,
              dots: true,
              fade: false,
              adaptiveHeight: false,
              speed: 300,
              cssEase: 'ease',
              lazyLoad: 'progressive'
            });
          } else {
            slider.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
              fade: false,
              adaptiveHeight: true,
              speed: 300,
              cssEase: 'ease',
              lazyLoad: 'progressive'
            });
          }
        }

        if (slider.hasClass('slick-initialized')) {
          slider.slick('setPosition');
        }
      } catch (error) {
        /* Keep the CSS native swipe fallback available if Slick fails. */
        if (window.console && console.warn) console.warn('MRD carousel refresh:', error);
      }
    });
  }

  function schedule(delay) {
    if (handle !== null) window.clearTimeout(handle);
    handle = window.setTimeout(refreshMobileCarousels,
      typeof delay === 'number' ? delay : 100);
  }

  function onReady() {
    schedule(150);
    window.setTimeout(function () { schedule(100); }, 800);
    window.setTimeout(function () { schedule(100); }, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  window.addEventListener('load', function () { schedule(100); });
  window.addEventListener('pageshow', function () { schedule(140); });
  window.addEventListener('resize', function () { schedule(160); }, { passive: true });
  window.addEventListener('orientationchange', function () { schedule(300); }, { passive: true });
  document.addEventListener('shopify:section:load', function () { schedule(140); });

  document.addEventListener('load', function (event) {
    var target = event.target;
    if (target && target.tagName === 'IMG' && target.closest &&
        target.closest(selector)) {
      schedule(100);
    }
  }, true);
})();
